import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';

export const useDeletePerk = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const { mutate: deletePerk, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.DELETE], {
    mutationFn: ({ id }: { id: string }) =>
      ApiService.delete(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id],
        },
        { regularBackend: true },
      ),
    onSuccess: (_, { id }) => {
      invalidateQuery(id);
      toast.success('Perk Successfully deleted');
    },
    defaultErrorHandling: false,
    onError: () => {
      toast.error('Couldn’t delete. Please try again');
    },
  });

  return {
    isPending,
    deletePerk,
  };
};
